
<template>
  <v-container fill-height fluid grid-list-xl>
    <Loader :loading="loading" />
    <v-layout justify-center wrap>
      <v-flex md12>
        <material-card
          color="green"
          title="Список"
          :text="total + ' аккаунтов'"
        >
          <v-btn color="success" @click="dialog = true" class="mr-2" text
            >Добавить аккаунт</v-btn
          >
          <v-btn color="primary" @click="getItems(false)" text>Обновить</v-btn>
          <div class="mt-2">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Поиск..."
              class="sticky search"
              :loading="loadingSearch"
              single-line
              hide-details
              clearable="true"
            ></v-text-field>
          </div>
          <v-data-table :headers="headers" :items="PagesList" hide-actions>
            <template slot="headerCell" slot-scope="{ header }">
              <span
                class="subheading font-weight-light text-success text--darken-3"
                v-text="header.text"
              />
            </template>
            <template slot="items" slot-scope="{ item }">
              <td class="text-xs-left">
                <span v-if="item.ID_1C">{{ item.ID_1C }}</span>
                <span v-else>Не установлено</span>
              </td>
              <td class="text-xs-left">{{ item.name }}</td>
              <td class="text-xs-left">{{ item.phone }}</td>
              <td class="text-xs-left">
                <span v-if="item.name_company">{{ item.name_company }}</span>
                <span v-else>Не установлено</span>
              </td>
              <td class="text-xs-left">
                <span v-if="item.group">{{ item.group.title }}</span>
                <span v-else>Нет группы</span>
              </td>
              <td class="text-xs-left">
                <span class="text-success" v-if="item.is_notified"
                  >Уведомлен</span
                >
                <span v-else>Не уведомлен</span>
              </td>
              <td class="text-xs-left">{{ item.created_at | dateTime }}</td>
              <td class="text-xs-right min-width100">
                <v-icon @click="open(item)">mdi-pencil</v-icon>
              </td>
            </template>
          </v-data-table>
          <div class="horizontal-scroll">
            <v-pagination
              total-visible="20"
              v-if="last_page > 1"
              v-model="page"
              class="my-4"
              :length="last_page"
            ></v-pagination>
          </div>
        </material-card>
      </v-flex>
    </v-layout>

    <v-dialog
      persistent
      fullscreen
      transition="dialog-bottom-transition"
      v-model="dialogShow"
    >
      <v-card>
        <Loader :loading="loading" absolute="true" />
        <v-btn class="close default v-btn--simple" @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-card-text>
          <div class="body-2 mt-5">Номер телефона</div>
          <v-text-field
            :readonly="true"
            v-model="dataItem.phone"
            label="+998XXYYYZZHH"
          ></v-text-field>
          <br />
          <br />
          <div v-if="$store.state.role[5]">
            <v-text-field
              v-model="new_password"
              label="Новый пароль"
            ></v-text-field>
            <v-btn color="primary" text @click="notify()"
              >Установить пароль и отправить СМС</v-btn
            >
            <br />
            <br />
            <br />
          </div>
          <div class="body-2 mb-2">Имя</div>
          <v-text-field
            v-model="dataItem.name"
            label="Ввидите имя"
            hide-details
          ></v-text-field>
          <br />
          <div class="body-2 mb-2">ID 1C</div>
          <v-text-field
            v-model="dataItem.ID_1C"
            label="ID из 1с"
            hide-details
          ></v-text-field>
          <br />

          <div class="body-2 mb-2">Лимит крдитной линии</div>
          <v-text-field
            readonly
            v-model="dataItem.deposit_limit"
            label="Лимит крдитной линии"
            hide-details
          ></v-text-field>
          <br />
          <div class="body-2 mb-2">Долг</div>
          <v-text-field
            readonly
            v-model="dataItem.debt"
            label="Долг"
            hide-details
          ></v-text-field>
          <br />

          <div class="body-2 mb-2">Название организации</div>
          <v-text-field
            v-model="dataItem.name_company"
            label="Ввидите  организацию"
            hide-details
          ></v-text-field>
          <br />
          <div class="body-2 mb-2">Адрес</div>
          <v-text-field
            v-model="dataItem.address"
            label="Ввидите  адрес"
            hide-details
          ></v-text-field>
          <br />
          <div class="body-2 mt-2 mb-2">Группа</div>
          <multiselect
            v-model="dataItem.group"
            :options="group"
            :multiple="false"
            placeholder="Выберите группу"
            track-by="id"
            label="title"
          >
            <span slot="noResult">Загрузка групп...</span>
          </multiselect>
          <br />
          <br />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions v-if="$store.state.role[6]" class="text-xs-center">
          <v-btn color="success" text @click="addItem">
            <span v-if="dataItem.id">Сохранить</span>
            <span v-else>Добавить аккаунт</span>
          </v-btn>
          <v-btn color="primary" text @click="closeDialog">Отмена</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Loader from "../../helper/Loader";

import { mapMutations } from "vuex";
import Page from "../Pages/Page";

export default {
  data: () => ({
    Page_title: "",
    PageAddModal: false,
    page: 1,
    searcher: null,
    loadingSearch: true,
    loading: true,
    last_page: 0,
    new_password: "",
    search: "",
    headers: [
      {
        sortable: false,
        text: "ID 1C",
        value: "dealer.title",
      },
      {
        sortable: false,
        text: "Дитрибьютор",
        value: "dealer.title",
      },

      {
        sortable: false,
        text: "Номер телефона",
        value: "dealer.phone_number",
      },
      {
        sortable: false,
        text: "Организация",
        value: "dealer.phone_number",
      },
      {
        sortable: false,
        text: "Группа",
        value: "dealer.phone_number",
      },
      {
        sortable: false,
        text: "Статус",
        value: "dealer.phone_number",
      },
      {
        sortable: false,
        text: "Дата создания",
        value: "dealer.phone_number",
      },
      {
        sortable: false,
        text: "",
        value: "dealer.phone_number",
      },
    ],
    PagesList: [],
    pageID: null,
    total: 0,
    dialog: false,
    dataItem: {
      id: null,
      is_active: 1,
      phone: null,
      group_id: null,
      name: null,
      name_company: null,
      address: null,
      group: null,
    },
    group: [],
  }),
  components: { Page, Loader },
  methods: {
    ...mapMutations(["SET_USER", "SET_BADGE_ORDERS"]),
    setOrders(val) {
      if (val) {
        this.getItems();
      }
    },
    getItems(noLoading) {
      if (!noLoading) this.loading = true;

      axios
        .get("admin/distributors/list", {
          params: {
            page: this.page,
            search: this.search,
          },
        })
        .then((response) => {
          this.PagesList = response.data.data;
          this.last_page = response.data.last_page;
          this.total = response.data.total;
        })
        .catch((error) => {})
        .finally(() => {
          this.loadingSearch = false;
          this.loading = false;
        });
    },

    getGroups() {
      axios.get("admin/distributors/group/list").then((response) => {
        this.group = response.data;
      });
    },
    open(data) {
      this.dataItem = data;
    },
    closeDialog() {
      this.dialog = false;
      this.dataItem = {
        id: null,
        is_active: 1,
        phone: null,
        group_id: null,
        name: null,
        name_company: null,
        address: null,
        group: null,
      };
    },

    addItem() {
      this.loading = true;
      axios
        .post("admin/distributors/set", this.dataItem)
        .then((response) => {
          this.$toast.success({
            title: this.vendor_code,
            message: "Аккаунт успешно добавлен",
          });
          this.dataItem = response.data;
          this.getItems();
          setTimeout(() => {
            // this.getItems();
          }, 300);
        })
        .catch((error) => {
          let data = error.response.data;
          if (data.errors) {
            let k = 0;
            Object.keys(data.errors).forEach((item) => {
              let err = data.errors[item];
              k++;
              for (let i = 0; i < err.length; i++) {
                setTimeout(() => {
                  this.$toast.error({
                    title: "Ошибка",
                    message: err[i],
                  });
                }, 100 * k);
              }
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    notify() {
      this.$dialog
        .confirm("Вы точно хотите изменить пароль?", {
          okText: "Да, хочу",
          cancelText: "Отмена",
        })
        .then(() => {
          this.loading = true;
          axios
            .put("admin/distributors/notify", {
              phone: this.dataItem.phone,
              password: this.new_password,
            })
            .then((response) => {
              this.$toast.success({
                title: this.dataItem.phone,
                message: "Пароль успешно отправлен на данный номер",
              });

              this.tg({
                object: "#changePasswordDistributor",
                id: this.dataItem.phone,
                password: this.new_password,
              });

              this.new_password = "";
              this.dataItem = response.data;
              setTimeout(() => {
                this.getItems();
              }, 300);
            })
            .catch((error) => {
              let data = error.response.data;
              if (data.errors) {
                let k = 0;
                Object.keys(data.errors).forEach((item) => {
                  let err = data.errors[item];
                  k++;
                  for (let i = 0; i < err.length; i++) {
                    setTimeout(() => {
                      this.$toast.error({
                        title: "Ошибка",
                        message: err[i],
                      });
                    }, 100 * k);
                  }
                });
              }
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(() => {});
    },
    tg(obj) {
      let message = JSON.stringify(obj);
      axios.post("notify/telegram", {
        message: message,
      });
    },
  },
  watch: {
    search() {
      this.loadingSearch = true;
      clearTimeout(this.searcher);
      this.searcher = setTimeout(() => {
        this.page = 1;
        this.getItems(true);
      }, 1500);
    },
    page() {
      setTimeout(() => {
        this.getItems();
      }, 300);
    },
  },
  mounted() {
    this.getGroups();
    this.getItems();
  },
  computed: {
    dialogShow: {
      get() {
        return this.dialog || this.dataItem.id ? true : false;
      },
    },
  },
};
</script>